import KeenSlider from "keen-slider";
// import "keen-slider/keen-slider.min.css";

class ButtonSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.slidesContainer = this.querySelector(".keen-slider");
    this.slides = this.querySelectorAll(".keen-slider__slide");
    const options = JSON.parse(this.getAttribute("data-slider-options"));
    const buttonId = this.getAttribute("data-button-id");

    const useIndexButtons = this.slidesContainer.getAttribute(
      "data-use-index-btns"
    );

    // get left, right nav buttons and add click events to them
    const navButtons = this.querySelectorAll(".slider-button");
    if (navButtons.length > 0) {
      if (navButtons[0]) {
        navButtons[0].addEventListener("click", () => this.slider.prev());
      }
      if (navButtons[1]) {
        navButtons[1].addEventListener("click", () => {
          this.slider.next();
        });
      }
    }

    // get dots and add click events to them
    let dots = this.querySelectorAll(".dot");
    let thumbnails = this.querySelectorAll(".thumbnail");
    let progressBar = this.querySelector(".progress-bar");

    const handleDotClick = (index) => () => {
      this.slider.moveToIdx(index, true);
      dots.forEach((dot) => dot.classList.remove("active"));
      dots[index].classList.add("active");
    };

    if (dots.length > 0) {
      dots.forEach((dot, index) => {
        dot.addEventListener("click", handleDotClick(index));
        dots[0].classList.add("active");
      });
    }

    if (thumbnails.length > 0) {
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener("click", handleDotClick(index));
        thumbnails[0].classList.add("active");
      });
    }

    // get buttons that update slider slides and add events to them
    const handleClick = () => {
      setTimeout(() => this.slider.update(options, 0), 0);
      let dots = this.querySelectorAll(".dot");
      if (dots.length === 0) return;
      dots = this.querySelectorAll(".dot");
      dots.forEach((dot, index) => {
        dot.addEventListener("click", handleDotClick(index));
        dots[0].classList.add("active");
      });
    };

    let buttons;
    if (buttonId) {
      buttons = document.querySelectorAll(`.${buttonId}`);
    } else {
      buttons = this.querySelectorAll(".button__tab");
    }
    buttons.forEach((button) => button.addEventListener("click", handleClick));
    buttons.forEach((button) => button.addEventListener("focus", handleClick));

    if (useIndexButtons === "true") {
      // get index buttons and move the active slide to that index
      const handleIndexButtonClick = (index) => () => {
        this.slider.moveToIdx(index, true);
      };

      const indexButtons = document.querySelectorAll(".index-btn");

      if (indexButtons.length > 0) {
        indexButtons.forEach((button, index) => {
          button.addEventListener("click", handleIndexButtonClick(index));
        });
      }
    }

    // get slide count elements and update them on events
    const slideCurrent = this.querySelector(".slide-current");
    const slideTotal = this.querySelector(".slide-total");

    this.slider = new KeenSlider(this.slidesContainer, options);

    this.slider.on("updated", () => {
      this.slides.forEach((slide) => {
        let currentSlideIndex, totalSlideCount;
        if (slideCurrent) {
          slideCurrent.textContent = this.slider.track.details.rel + 1;
          currentSlideIndex = this.slider.track.details.rel + 1;
        }
        if (slideTotal) {
          slideTotal.textContent = this.slider.track.details.slides.length;
          totalSlideCount = this.slider.track.details.slides.length;
        }
        if (progressBar) {
          const progress = (currentSlideIndex * 100.0) / totalSlideCount;
          progressBar.style.width = `${progress}%`;
        }
        const index = parseInt(slide.getAttribute("data-active-slide"));
        if (index) {
          this.slider.moveToIdx(index, true);
        }
      });
    });
    // update dot classes on events
    this.slider.on("optionsChanged", () => {
      dots = this.querySelectorAll(".dot");
      if (dots.length === 0) return;
      dots.forEach((dot, index) => {
        dot.addEventListener("click", handleDotClick(index));
        dots[0].classList.add("active");
      });
    });
    this.slider.on("slideChanged", (container) => {
      container.slides.forEach((slide, index) => {
        if (index === container.track.details.rel) {
          slide.classList.add("active");
        } else {
          slide.classList.remove("active");
        }
      });
      if (slideCurrent) {
        slideCurrent.textContent = this.slider.track.details.rel + 1;
      }
      if (slideTotal) {
        slideTotal.textContent = this.slider.track.details.slides.length;
      }
      const currentSlideIndex = this.slider.track.details.rel + 1;
      const totalSlideCount = this.slider.track.details.slides.length;

      if (progressBar) {
        const progress = (currentSlideIndex * 100.0) / totalSlideCount;
        progressBar.style.width = `${progress}%`;
      }

      if (dots.length === 0 && thumbnails.length === 0) return;
      if (thumbnails.length > 0) {
        thumbnails.forEach((thumbnail) => thumbnail.classList.remove("active"));
        thumbnails[this.slider.track.details.rel].classList.add("active");
      }
      if (dots.length > 0) {
        dots.forEach((dot) => dot.classList.remove("active"));
        dots[this.slider.track.details.rel].classList.add("active");
      }
    });

    setTimeout(() => {
      if (this.slider) {
        this.slider.update();
      }
    }, 0);
    const _this = this;
    window.addEventListener(
      "resize",
      setTimeout(() => {
        if (_this.slider) {
          _this.slider.update();
        }
      }, 0)
    );
  }

  // Public method to update the slider
  updateSlider() {
    if (this.slider) {
      setTimeout(() => {
        this.slider.update();
      }, 0);
    } else {
      console.warn("Slider not initialized yet");
    }
  }

  // Public method to get slider instance
  getSlider() {
    return this.slider;
  }
}

/*
  Register the element.
  Set timeout allows us to grab the dynamic classes added by Alpine
  after they have been added to the DOM.
*/
setTimeout(() => {
  if (!customElements.get("button-slider"))
    customElements.define("button-slider", ButtonSlider);
}, 0);
